var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu-item',_vm._g(_vm._b({},'el-menu-item',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._t("title")],2)}
var staticRenderFns = []

export { render, staticRenderFns }